<template>
  <Option
    v-bind="$attrs"
    type="checkbox"
  >
    <slot name="default" />
  </Option>
</template>

<script>
import Option from 'Web/Form/Inputs/Option.vue';

export default {
  inheritAttrs: false,
  components: {
    Option,
  },
  setup: Option.setup
}
</script>
